



























// @ is an alias to /src
import { AloPlat, getDefaultAloPlat } from '@/models/alo/AloPlat'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {ItemPanier} from '@/models/alo/ItemPanier'
import { VuetifyConfirmObject } from 'node_modules/vuetify-confirm/types'
import { getDefaultAloArbo } from '@/models/alo/AloArbo'
import { mixins } from 'vue-class-component'
import BasePlat from '@/components/carte/BasePlat'
import { groupByNumber } from '@/utils/groupBy'

@Component({
  name: 'MenuBreakfastCarte',  
  props: {
    show:{
      type:Boolean,
      default:false
    },
    itemPanier:{
      type:Object,
      required:true
    }
  }
})
export default class MenuBreakfastCarte extends mixins(BasePlat) {
    
  show!:boolean  
  itemPanier!:ItemPanier

  get supplementsGroup(){
    return groupByNumber(this.itemPanier.supplements, it => it.sectionId ?? 0).map(it => {return {...it, section: this.platsDic[it.key] || getDefaultAloPlat()}})
  }

  get platsDic(){
    return this.$store.myGetters.platsDic
  }

  get showDialog(){    
    return this.show
  }

  set showDialog(value) {
    this.$emit("update:show",value)
  } 


  get section(){
    return this.arbosDic[this.plat.arboId!] ?? getDefaultAloArbo()
  }
  
    
  get plats() {
    return this.section.platsIds?.map(id => this.platsDic[id]) ?? []
  }

}
